export const EDITOR_TEXTS = {
	cancel: 'Cancel',
	saveChanges: 'Save changes',
	saving: 'Saving changes…',
	arrivalLabel: (code) => `Arrival at ${code ?? 'station'}`,
	departureLabel: (code) => `Departure at ${code ?? 'station'}`,
	timeOrderErrorMessage: (fromCode, toCode) =>
		fromCode === toCode
			? `Arrival at ${fromCode ?? 'this station'} must be before departure.`
			: `Departure at ${fromCode ?? 'previous station'} must not be later than arrival at ${toCode ?? 'next station'}.`,
};
